import { signIn } from '@/services/authAPI';

export default {
  state: {
    isAuth: false,
    isViewAdminPanel: false,
  },
  mutations: {
    setStatusAuth(state, isAuth) {
      state.isAuth = isAuth;
    },
    setStatusViewAdminPanel(state, isViewAdminPanel) {
      state.isViewAdminPanel = isViewAdminPanel;
    },
  },
  actions: {
    async fetchAuth(context, credits) {
      await signIn(credits.username, credits.password);
      context.commit('setStatusAuth', true);
      context.commit('setStatusViewAdminPanel', true);
      localStorage.setItem('isViewAdminPanel', true);
    },

    async logout(context){
      context.commit('setStatusAuth', false);
      context.commit('setStatusViewAdminPanel', false);
      localStorage.setItem('isViewAdminPanel', false);
      localStorage.removeItem('accessToken');
    }
  },
  getters: {
    getIsAuth(state) {
      return state.isAuth;
    },
    getIsViewAdminPanel(state) {
      return state.isViewAdminPanel;
    },
  },
};